'use client';

import { useCurrentLocale } from '@locales/client';
import { locales } from '@locales/locales';
import { usePathname } from 'next/navigation';

export default function HreflangTags() {
  const pathname = usePathname();
  const currentLocale = useCurrentLocale();

  const baseUrl =
    typeof window !== 'undefined' &&
    `${window.location.protocol}//${window.location.host}`;

  const getCleanPath = (): string => {
    for (const locale of locales) {
      if (pathname === `/${locale}`) return '';
      if (pathname.startsWith(`/${locale}/`)) {
        return pathname.slice(locale.length + 1);
      }
    }
    return pathname;
  };

  const cleanPath = getCleanPath();

  return (
    baseUrl && (
      <>
        {locales
          .filter((locale) => locale !== currentLocale)
          .map((locale) => (
            <link
              key={locale}
              rel="alternate"
              hrefLang={locale}
              href={`${baseUrl}/${locale}${cleanPath}`}
            />
          ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`${baseUrl}/en${cleanPath}`}
        />
      </>
    )
  );
}
